import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vue-awesome/icons'
import moment from 'moment'
import Icon from 'vue-awesome/components/Icon.vue'
import axios from './request'
import VueAxios from 'vue-axios'

import './assets/font_1949542_9w7vbp70l3h/iconfont.css'
import './assets/font_bjxp0qd5h5r/iconfont.css'
import Vant from 'vant'
import { Popover } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css'
import VConsole from 'vconsole'
//高德地图
import VueAMap from 'vue-amap';
console.log(VueAMap)
Vue.use(VueAMap);
Vue.use(ElementUI);
Vue.prototype.$moment = moment;
Vue.config.ignoredElements = ['wx-open-lanuch-weapp']
// // 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德key
  key: '30c20d854871dff04329ac9ad49c2b91',
  // 插件集合 （插件按需引入）
  // plugin: ['AMap.Geolocation']
  plugin: ['AMap.Geocoder', 'AMap.Geolocation', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
});



// new VConsole()
Vue.use(Popover);
Vue.use(Vant)
// localStorage.clear()
import api from './api'
Vue.prototype.$https = api
// import 'lib-flexible/flexible.js'

Vue.use(VueAxios, axios)

Vue.component('v-icon', Icon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
